(function () {
  if (window.ItemManagerRankingInitialized) {
    if (typeof window.ItemManagerRankingApply === "function") {
      window.ItemManagerRankingApply();
    }
    return;
  }

  window.ItemManagerRankingInitialized = true;

  var DEFAULT_API_BASE_URL = "https://admin.e-asakura.net";
  var DEFAULT_BRAND_KEY = "en-neume";
  var DEFAULT_LIMIT = 50;
  var CACHE_TTL_MS = 60 * 1000;
  var STALE_CACHE_TTL_MS = 10 * 60 * 1000;
  var memoryCache = new Map();

  function normalizeProductKey(value) {
    var text = String(value || "").trim();
    var match = text.match(/Product\/(\d+)$/);
    return (match ? match[1] : text).toLowerCase();
  }

  function parseLimit(value) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) return DEFAULT_LIMIT;
    return Math.min(Math.floor(parsed), DEFAULT_LIMIT);
  }

  function buildUrl(scope) {
    var apiBaseUrl = (
      scope.dataset.itemManagerRankingApiBaseUrl || DEFAULT_API_BASE_URL
    ).replace(/\/+$/, "");
    var brandKey =
      scope.dataset.itemManagerRankingBrandKey || DEFAULT_BRAND_KEY;
    var limit = parseLimit(scope.dataset.itemManagerRankingLimit);
    var url = new URL(apiBaseUrl + "/api/marketing/ranking");
    url.searchParams.set("brandKey", brandKey);
    url.searchParams.set("limit", String(limit));
    return url.toString();
  }

  function buildCacheKey(url) {
    return "item-manager-ranking:v3:" + url;
  }

  function getStorage(name) {
    try {
      return window[name] || null;
    } catch (error) {
      return null;
    }
  }

  function getCacheStores() {
    return [getStorage("sessionStorage"), getStorage("localStorage")].filter(
      Boolean,
    );
  }

  function readCache(cacheKey) {
    var now = Date.now();
    var stores = getCacheStores();
    for (var index = 0; index < stores.length; index += 1) {
      var storage = stores[index];
      var raw;
      var cached;

      try {
        raw = storage.getItem(cacheKey);
        if (!raw) continue;
        cached = JSON.parse(raw);
      } catch (error) {
        continue;
      }

      var age = now - Number((cached && cached.savedAt) || 0);
      if (!cached || !cached.payload || age < 0 || age > STALE_CACHE_TTL_MS)
        continue;

      return {
        isFresh: age <= CACHE_TTL_MS,
        payload: cached.payload,
      };
    }

    return null;
  }

  function writeCache(cacheKey, payload) {
    var value = JSON.stringify({
      savedAt: Date.now(),
      payload: payload,
    });

    getCacheStores().forEach(function (storage) {
      try {
        storage.setItem(cacheKey, value);
      } catch (error) {
        // Storage can be unavailable in private browsing; the network cache still covers this.
      }
    });
  }

  function preconnect(url) {
    try {
      var origin = new URL(url).origin;
      if (
        document.querySelector(
          'link[data-item-manager-ranking-preconnect="' + origin + '"]',
        )
      )
        return;

      var link = document.createElement("link");
      link.rel = "preconnect";
      link.href = origin;
      link.crossOrigin = "anonymous";
      link.setAttribute("data-item-manager-ranking-preconnect", origin);
      document.head.appendChild(link);
    } catch (error) {
      // Invalid URLs are handled by fetch.
    }
  }

  function requestRanking(scope) {
    var url = buildUrl(scope);
    var cacheKey = buildCacheKey(url);
    if (memoryCache.has(url)) return memoryCache.get(url);

    preconnect(url);
    var request = fetch(url, {
      credentials: "omit",
      headers: { Accept: "application/json" },
      priority: "high",
    })
      .then(function (response) {
        if (!response.ok)
          throw new Error("Ranking API error: " + response.status);
        return response.json();
      })
      .then(function (payload) {
        writeCache(cacheKey, payload);
        return payload;
      });

    memoryCache.set(url, request);
    return request;
  }

  function getProductBlocks(scope) {
    return Array.prototype.slice
      .call(
        scope.querySelectorAll(
          "product-block.product-block[data-product-id], .product-block[data-product-id]",
        ),
      )
      .filter(function (block) {
        return (
          !block.classList.contains("collection-block") &&
          block.querySelector(".block-inner")
        );
      });
  }

  function getRankingEntries(scope) {
    return getProductBlocks(scope).map(function (block) {
      var unit = block.closest(".slider__item") || block;
      return {
        block: block,
        unit: unit,
      };
    });
  }

  function getReorderParent(entries) {
    if (!entries.length) return null;
    var parent = entries[0].unit.parentElement;
    return entries.every(function (entry) {
      return entry.unit.parentElement === parent;
    })
      ? parent
      : null;
  }

  function addRankBadge(block, rank) {
    var inner = block.querySelector(".block-inner");
    if (!inner) return;

    // 配置基準は .image-cont（Symmetry標準 / position:relative + overflow:hidden）。
    // バッジと商品画像が同じ原点(0,0)を共有するため、サブピクセル丸めが必ず一致する。
    var target = inner.querySelector(".image-cont");
    if (!target) return;

    var badge = inner.querySelector(".item-manager-ranking-badge");
    if (badge && badge.parentElement !== target) {
      badge.remove();
      badge = null;
    }
    if (!badge) badge = target.querySelector(".item-manager-ranking-badge");
    if (!badge) {
      badge = document.createElement("div");
      badge.className = "item-manager-ranking-badge";
      target.appendChild(badge);
    }
    badge.textContent = String(rank);
  }

  function annotateCurrentOrder(scope) {
    getProductBlocks(scope).forEach(function (block, index) {
      addRankBadge(block, index + 1);
    });
  }

  function markReady(scope) {
    scope.classList.add(
      "item-manager-ranking-scope",
      "item-manager-ranking-ready",
    );
    scope.classList.remove("item-manager-ranking-pending");
  }

  // 商品ブロックを除外した後、カルーセルにスライド集合を読み直させる。
  // CarouselSlider は `.slider__item:not([hidden])` を参照し refresh() で再計算する。
  function refreshCarousels(scope) {
    var carousels = scope.querySelectorAll("carousel-slider");
    Array.prototype.forEach.call(carousels, function (carousel) {
      if (carousel && typeof carousel.refresh === "function") {
        try {
          carousel.refresh();
        } catch (error) {
          // refresh 失敗時もランキング自体は表示済みなので無視する。
        }
      }
    });
  }

  function applyRanking(scope, payload) {
    var entries = getRankingEntries(scope);
    var parent = getReorderParent(entries);
    var items = payload && Array.isArray(payload.items) ? payload.items : [];

    scope.classList.add("item-manager-ranking-scope");

    if (!parent || !items.length) {
      annotateCurrentOrder(scope);
      markReady(scope);
      return;
    }

    var entryByProductKey = new Map();
    entries.forEach(function (entry) {
      var productId = normalizeProductKey(entry.block.dataset.productId);
      var productHandle = normalizeProductKey(
        entry.block.dataset.productHandle,
      );
      if (productId) entryByProductKey.set(productId, entry);
      if (productHandle) entryByProductKey.set(productHandle, entry);
    });

    var used = new Set();
    var orderedEntries = [];
    items.forEach(function (item) {
      var keys = [
        normalizeProductKey(item && item.shopifyProductId),
        normalizeProductKey(item && item.shopifyProductHandle),
        normalizeProductKey(item && item.productCode),
      ];
      var entry = null;

      keys.some(function (key) {
        entry = key ? entryByProductKey.get(key) : null;
        return Boolean(entry);
      });

      if (!entry || used.has(entry.unit)) return;
      used.add(entry.unit);
      orderedEntries.push(entry);
    });

    if (!orderedEntries.length) {
      annotateCurrentOrder(scope);
      markReady(scope);
      return;
    }

    // API ランキングに無い商品（管理画面で非表示・RANKING 対象外）は
    // ランキング表示から除外する。並びと収録は Shopify コレクション側の
    // 保存時同期で管理画面ランキングに揃うため、残った非対象は描画しない。
    var removedAny = false;
    entries.forEach(function (entry) {
      if (used.has(entry.unit)) return;
      if (entry.unit.parentElement) {
        entry.unit.parentElement.removeChild(entry.unit);
        removedAny = true;
      }
    });

    orderedEntries.forEach(function (entry) {
      parent.appendChild(entry.unit);
    });

    if (removedAny) refreshCarousels(scope);

    annotateCurrentOrder(scope);
    markReady(scope);
  }

  function applyAll() {
    var scopes = Array.prototype.slice.call(
      document.querySelectorAll("[data-item-manager-ranking-scope]"),
    );
    scopes.forEach(function (scope) {
      scope.classList.add("item-manager-ranking-scope");
      var cacheKey = buildCacheKey(buildUrl(scope));
      var cached = readCache(cacheKey);

      if (cached && cached.payload && cached.isFresh) {
        applyRanking(scope, cached.payload);
        return;
      }

      requestRanking(scope)
        .then(function (payload) {
          applyRanking(scope, payload);
        })
        .catch(function () {
          if (cached && cached.payload) {
            applyRanking(scope, cached.payload);
            return;
          }
          annotateCurrentOrder(scope);
          markReady(scope);
        });
    });
  }

  window.ItemManagerRankingApply = applyAll;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll);
  } else {
    applyAll();
  }

  document.addEventListener("shopify:section:load", applyAll);
})();
